import {
  FooterWrapper,
  FooterDisclosures,
  FooterLogo,
  FooterVersion,
  DisclosuresContent,
  EqualHousingIcon,
  NcuaIconContainer,
  HoverText,
  HoverTextTwo,
  ConnectSupport,
} from './Footer.styles';
import type { FC } from 'react';
import SafeHTML from '@utils/safeHTML';
import { useAppSelector } from '@app/hooks';
import SocialLink from '../SocialLinks/SocialLinks';
import { replaceTemplateVariables } from '@utils/replaceTemplateVariables';
export interface FooterProps {
  variant: 'primary' | 'secondary';
}

export const Footer: FC<FooterProps> = ({ variant }) => {
  const { step, value } = useAppSelector((state) => state.currentPage);
  const isVmoPage = step === 3;
  const isCompletionPage = value === 'Completion';
  let templateConfig = useAppSelector((state) => state.TemplateConfig);
  const isGlanceEnabled = templateConfig?.glanceSettings?.isEnabled;
  const lenderName = templateConfig?.lenderName || '';
  const isLoanDepot = lenderName.toLowerCase() === 'loandepot';
  const currentYear = new Date().getFullYear();
  const logo = templateConfig?.globalTheme?.logo;
  const isVmoV2 = (templateConfig?.features?.vmoRedesign?.isEnabled && isVmoPage) ?? false;
  const footerOptions = isVmoV2 ? templateConfig?.pages?.footer?.footerVmoV2 : templateConfig?.pages?.footer?.defaultFooter;

  return (
    <FooterWrapper $variant={variant} data-testid="footer">
      <FooterDisclosures $isVmoV2={isVmoV2}>
        {isCompletionPage && isLoanDepot && (
          <>
            <a href={templateConfig?.pages?.returnPage} target="_blank" rel="noopener noreferrer">
              <img src={logo} alt={`${templateConfig?.lenderName}-logo`} loading="lazy" />
            </a>
            <SocialLink socialLinks={templateConfig?.pages?.socialLinks || []} />
          </>
        )}
        <DisclosuresContent $variant={variant} $isVmoV2={isVmoV2} data-testid="footer-disclosures-one" $isHidden={footerOptions?.footerDisclosuresOne?.isHidden ?? false}>
          <SafeHTML tag="p" html={replaceTemplateVariables(footerOptions?.footerDisclosuresOne?.text || `©${currentYear} ${lenderName}`, templateConfig)} />
        </DisclosuresContent>
        <DisclosuresContent $variant={variant} $isVmoV2={isVmoV2} data-testid="footer-disclosures-two" $isHidden={footerOptions?.footerDisclosuresTwo?.isHidden ?? false}>
          <SafeHTML tag="p" html={replaceTemplateVariables(footerOptions?.footerDisclosuresTwo?.text || 'Contact Us 866.243.1111 current', templateConfig)} />
        </DisclosuresContent>
        <ConnectSupport
          $isHidden={!isGlanceEnabled}
          role="button"
          tabIndex={isGlanceEnabled ? 0 : -1}
          aria-label="Connect to support"
          onClick={() => {
            if (typeof window !== 'undefined' && (window as any).GLANCE?.Cobrowse?.Visitor) {
              (window as any).GLANCE.Cobrowse.Visitor.startSession();
            }
          }}
        >
          <SafeHTML tag="p" html={footerOptions?.connectToSupport?.text || 'connect to support'} />
        </ConnectSupport>
        <FooterVersion $variant={variant} $isVmoV2={isVmoV2} data-testid="footer-version" $isHidden={footerOptions?.support?.isHidden ?? false}>
          {footerOptions?.support?.text || 'current version 0.2.60.3'}
        </FooterVersion>
      </FooterDisclosures>
      {!isVmoV2 && (
        <FooterLogo>
          <NcuaIconContainer $isHidden={footerOptions?.compliance?.logo?.isHidden ?? false}>
            <img
              src={
                footerOptions?.compliance?.logo?.url ||
                'https://firstclosenonprodmedia.blob.core.windows.net/media/3_ld_default_application/Equal-Housing-Opportunity-logo-52-BB024373-seeklogo-com.png'
              }
              alt={footerOptions?.compliance?.logo?.text || 'Equal Housing Opportunity'}
              loading="lazy"
            />
            <HoverTextTwo>{footerOptions?.compliance?.logo?.text}</HoverTextTwo>
          </NcuaIconContainer>
          <EqualHousingIcon $isHidden={footerOptions?.compliance?.logo2?.isHidden ?? false}>
            <img
              src={
                footerOptions?.compliance?.logo2?.url ||
                'https://firstclosenonprodmedia.blob.core.windows.net/media/3_ld_default_application/Equal-Housing-Opportunity-logo-52-BB024373-seeklogo-com.png'
              }
              alt={footerOptions?.compliance?.logo2?.text || 'Equal Housing Opportunity'}
              loading="lazy"
            />
            <HoverText>{footerOptions?.compliance?.logo2?.text}</HoverText>
          </EqualHousingIcon>
        </FooterLogo>
      )}
    </FooterWrapper>
  );
};
